import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";

const CustomBreadcrumbs = ({ items, separator = "/", ...props }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs aria-label="breadcrumb" {...props}>
      {items.map((item, index) =>
        item.link ? (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            onClick={() => navigate(item.link)}
            style={{ cursor: "pointer" }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={index} color="textPrimary">
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
